import styles from "./Designer.module.css";

const ExternalStepNav = ({
    isCollapsed = false,
    onToggleCollapse,
    currentStep = 1,
    totalSteps = 3,
    onPrev,
    onPrimary,
    primaryDisabled = false,
    primaryLabel = "SIGUIENTE",
}) => {
    return (
        <div className={`${styles.externalStepNavWrap} ${isCollapsed ? styles.externalStepNavWrapCollapsed : ""}`}>
            <button
                type="button"
                className={`${styles.blockToggle} ${styles.navToggle} ${styles.footerDockToggle} ${
                    isCollapsed ? styles.footerDockToggleCollapsed : ""
                }`}
                onClick={onToggleCollapse}
                aria-label={isCollapsed ? "Expandir barra de pasos hacia arriba" : "Contraer barra de pasos hacia abajo"}
                title={isCollapsed ? "Expandir barra de pasos hacia arriba" : "Contraer barra de pasos hacia abajo"}
            >
                <i
                    className={`bi ${isCollapsed ? "bi-chevron-double-up" : "bi-chevron-double-down"}`}
                    aria-hidden="true"
                />
            </button>
            {!isCollapsed ? (
                <div className={styles.externalStepNav} role="navigation" aria-label="Navegación de pasos">
                    <button
                        type="button"
                        className={`${styles.btn} ${currentStep === 1 ? styles.btnDisabled : ""}`}
                        disabled={currentStep === 1}
                        onClick={onPrev}
                    >
                        ANTERIOR
                    </button>
                    <div className={styles.externalStepNavMeta}>
                        Paso {currentStep} de {totalSteps}
                    </div>
                    <button
                        type="button"
                        className={styles.btn}
                        onClick={onPrimary}
                        disabled={primaryDisabled}
                    >
                        {primaryLabel}
                    </button>
                </div>
            ) : null}
        </div>
    );
};

export default ExternalStepNav;
